import SeasonalityChartTooltip from '@page-components/condensed-timeline/sales-forecast/SeasonalityChartTooltip';
import { DateFormat, DateUtility } from '@utility/date';
import { theme } from '@utility/theme';
import { CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';

/**
 * Base Components For A Seasonal Chart
 * @returns {JSX.Element} - React component
 */
function SeasonalityChartBase() {
  return (
    <>
      {/* Renders horizontal and vertical grid lines */}
      <CartesianGrid vertical={false} stroke={`${theme.colors.lightGrey}1f`} />

      {/* Renders the X-axis for displaying data categories (dates) */}
      <XAxis
        dataKey="name"
        stroke={theme.colors.grey}
        tickFormatter={tick =>
          DateUtility.formatDate(tick, DateFormat.localeMonthDate)
        }
        interval="preserveStartEnd"
      />

      {/* Renders the Y-axis for displaying numeric values */}
      <YAxis
        label={{
          angle: -90,
          fill: theme.colors.grey,
          offset: 10,
          position: 'insideLeft',
          value: 'Units / Day',
        }}
        stroke={theme.colors.grey}
        tickCount={10}
      />

      {/* Displays a tooltip when hovering over data points */}
      <Tooltip
        animationEasing="ease-out"
        content={<SeasonalityChartTooltip />}
      />
    </>
  );
}

export default SeasonalityChartBase;
